import { Box, Typography } from "@mui/material";
import React, { FC } from "react";

interface InfoRowProps {
  label: string;
  value: React.ReactNode;
}

const InfoRow: FC<InfoRowProps> = ({ label, value }) => (
  <Box
    sx={{
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      py: 1,
      borderBottom: "1px solid",
      borderColor: "divider",
      "&:last-child": { borderBottom: "none" },
    }}
  >
    <Typography variant="body2" color="text.secondary" fontWeight={500}>
      {label}
    </Typography>
    <Typography variant="body2" fontWeight={600}>
      {value ?? "-"}
    </Typography>
  </Box>
);

export default InfoRow;
